module.exports = __webpack_public_path__ + "img/xk.12d401c8.svg";